import { FAQ_RAG_API_URL, SALES_BOT_FAQS_API_URL, UPDATE_FEEDBACK_API_URL } from '../../utils/apiUrls';
import { postRequest } from '../../utils/http';

export interface FaqApiResponse {
	q?: string[];
	a?: string[];
}

export interface RagApiResponse {
	response: string;
	citation?: string;
	likes?: number;
	dislikes?: number;
}

export const fetchFaqRagData = async (stepId: number, inputValue: string, created_by?: string): Promise<RagApiResponse> => {
	try {
		const faqRagResponse = await postRequest(FAQ_RAG_API_URL, {
			faq_category_id: stepId,
			query: inputValue,
			internet_speed: '',
			phone_plan: '',
			created_by: created_by,
		});

		return faqRagResponse;
	} catch (error) {
		console.error('Error calling FAQ RAG API:', error);
		throw error;
	}
};

export const updateFeedback = async (
	stepId: number,
	inputQuery: string,
	action: 'like' | 'dislike'
): Promise<{ likes?: number; dislikes?: number }> => {
	try {
		const response = await postRequest(UPDATE_FEEDBACK_API_URL, {
			category_id: stepId,
			search_key: inputQuery,
			action,
		});

		return response;
	} catch (error) {
		console.error('Error updating feedback:', error);
		throw error;
	}
};

export const fetchFaqDataHistory = async (data: any): Promise<FaqApiResponse> => {
	try {
		const response = await postRequest(SALES_BOT_FAQS_API_URL, data);
		return response;
	} catch (error) {
		console.error('Error calling FAQ data history API:', error);
		throw error;
	}
};
